export default __webpack_public_path__ + "static/media/Pranto.9e863dcc.png";